'use client'; // Error boundaries must be Client Components
import './[locale]/(frontend)/globals.css';
import { ThemeProvider } from '@/components/theme-provider';
import Link from 'next/link';
import type { Metadata } from 'next';

export const metadata: Metadata = {
  title: 'エラーが発生しました',
  description: 'サーバーでエラーが発生しました。',
};

export default function GlobalError({
  error: _error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    // global-error must include html and body tags
    <html lang="ja" suppressHydrationWarning>
      <body className="font-sans">
        <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
          <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 text-center">
            <h1 className="mb-4 text-4xl font-bold">エラーが発生しました</h1>
            <p className="mb-8 text-lg text-muted-foreground">
              サーバーでエラーが発生しました。時間をおいて再度お試しください。
            </p>
            <button type="button" onClick={() => reset()} className="text-primary hover:underline">
              再試行
            </button>
            <br />
            <Link href="/" className="text-primary hover:underline">
              ホームに戻る
            </Link>
          </div>
        </ThemeProvider>
      </body>
    </html>
  );
}
